module.exports=[
  {
    "nom": "Théâtre pour 2 mains",
    "annee": 2001,
    "adresse": "27 avenue de la Gare de Saint Joseph",
    "codepostal": 44300,
    "ville": "Nantes",
    "mail": "",
    "www": "http://www.theatrepour2mains.fr",
    "reseaux": "Scène d'Enfance - Assitej France",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Avec la Région",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 7,
    "diffusion_region": 40,
    "diffusion_france": 60,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Oui",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.2536267,
      -1.5233479
    ]
  },
  {
    "nom": "Compagnie Arts Symbiose",
    "annee": 2001,
    "adresse": "Espace Camille Flammarion, 7 bld de la République",
    "codepostal": 44380,
    "ville": "Pornichet",
    "mail": "cie.arts.symbiose@free.fr",
    "www": "https://www.cieartssymbiose.com/",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire\nScène d'Enfance - Assitej France",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 1,
    "diffusion": 2,
    "diffusion_region": 80,
    "diffusion_france": 20,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Structures petite enfance",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "Théâtre gestuel",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Non",
    "coords": [
        47.260479, -2.336663
    ]
  },
  {
    "nom": "Séverine Coulon",
    "annee": 2015,
    "adresse": "2 rue du lieutenant de monti",
    "codepostal": 44400,
    "ville": "Reze",
    "mail": "coulon.severine@free.fr",
    "www": "https://severinecoulon.com/",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire\nScène d'Enfance - Assitej France",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Bouffou Théâtre à la Coque et Le Grand Bleu à Lille",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 12,
    "diffusion_france": 72,
    "diffusion_monde": 16,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Oui",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Festivals",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
        47.185880, -1.553589
    ]
  },
  {
    "nom": "Cie La Lune Rousse",
    "annee": 1990,
    "adresse": "11 rue de dijon",
    "codepostal": 44800,
    "ville": "saint herblain",
    "mail": "lalunerousse@free.fr",
    "www": "http://www.lalunerousse.fr",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 1,
    "diffusion": 3,
    "diffusion_region": 20,
    "diffusion_france": 60,
    "diffusion_monde": 20,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Centre socio-culturels\nFestivals",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Arts du recit",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.2062728,
      -1.6152834
    ]
  },
  {
    "nom": "THEATRE DU RICTUS",
    "annee": 1997,
    "adresse": "27 RUE DU BUISSON",
    "codepostal": 44980,
    "ville": "SAINTE LUCE SUR LOIRE",
    "mail": "lmaindon@free.fr",
    "www": "https://theatredurictus.fr/",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Avec la DRAC",
    "structure_associee": "Non",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 6,
    "diffusion_france": 7,
    "diffusion_monde": 68,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Oui",
    "coords": [
      47.2602604,
      -1.4832301
    ]
  },
  {
    "nom": "CIE OSTEOROCK",
    "annee": 2005,
    "adresse": "7 place de la République",
    "codepostal": 49100,
    "ville": "ANGERS",
    "mail": "contact@osteorock.com",
    "www": "http://www.osteorock.com",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 1,
    "diffusion": 4,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Oui",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.4725177,
      -0.5546717
    ]
  },
  {
    "nom": "Compagnie Il est doux de faire les fous",
    "annee": 2017,
    "adresse": "10 rue Jacqueline Mazé",
    "codepostal": 49130,
    "ville": "Les Ponts-de-Cé",
    "mail": "ilestdoux@outlook.fr",
    "www": "https://ilestdouxdefairelesfous.wordpress.com/",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
        47.429455, -0.522039
    ]
  },
  {
    "nom": "Cie Ernesto Barytoni",
    "annee": 2010,
    "adresse": "14 bis rue du Beuvron",
    "codepostal": 49600,
    "ville": "Andrezé",
    "mail": "stephane@ernestobarytoni.com",
    "www": "http://www.ernestobarytoni.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 1,
    "diffusion": 4,
    "diffusion_region": 80,
    "diffusion_france": 20,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu scolaire\nCentres de loisirs\nCentre socio-culturels\nMilieu associatif\nComités d'entreprises\nStructures handicap\nÉvènementiel",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Non",
    "coords": [
      47.1724128,
      -0.9560851
    ]
  },
  {
    "nom": "Cie Art Zygote",
    "annee": 1997,
    "adresse": "25, rue albert Einstein",
    "codepostal": 53000,
    "ville": "LAVAL",
    "mail": "diffusion.artzygote@gmail.com",
    "www": "http://compagnieartzygote.blogspot.com",
    "reseaux": "Scène d'Enfance - Assitej France\nPlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 3,
    "diffusion_region": 51,
    "diffusion_france": 49,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu scolaire\nBibliothèques / Médiathèques\nMaisons de quartiers",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "Théâtre de papier",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      48.0550492,
      -0.741273582890258
    ]
  },
  {
    "nom": "THEATRE DE L'ECHAPPEE",
    "annee": 1987,
    "adresse": "Quartier Ferrié / 30 rue Henri Géret",
    "codepostal": 53000,
    "ville": "LAVAL",
    "mail": "francoisbechu@theatrelechappee.com",
    "www": "http://www.theatrelechappee.com",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 3,
    "diffusion": 3,
    "diffusion_region": 20,
    "diffusion_france": 30,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Structures petite enfance",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Oui",
    "coords": [
        48.079049, -0.784335
    ]
  },
  {
    "nom": "ANIMA COMPAGNIE",
    "annee": 2012,
    "adresse": "31 ALLEE DU VIEUX SAINT LOUIS BP 1424",
    "codepostal": 53014,
    "ville": "Laval",
    "mail": "animacompagnie53@gmail.com",
    "www": "http://www.animacompagnie.toile-libre.org",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 0,
    "diffusion": 0,
    "diffusion_region": 50,
    "diffusion_france": 50,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Oui",
    "coords": [
        48.072607, -0.773429
    ]
  },
  {
    "nom": "cie des arbres et des hommes",
    "annee": 2003,
    "adresse": "La Bondie",
    "codepostal": 53170,
    "ville": "VILLIERS CHARLEMAGNE",
    "mail": "desarbresetdeshommes@gmail.com",
    "www": "http://desarbresetdeshommes.org/",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 0,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Non",
    "coords": [
        47.932789, -0.703264
    ]
  },
  {
    "nom": "Collectif Label Brut",
    "annee": 2006,
    "adresse": "4 rue Horeau",
    "codepostal": 53200,
    "ville": "Chateau-Gontier",
    "mail": "communication@labelbrut.fr",
    "www": "http://www.labelbrut.fr",
    "reseaux": "Scènes d'Enfance - Assitej France Plato",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Avec la DRAC",
    "structure_associee": "Le Carré, Scène nationale - Centre d'art contemporain de Château-Gontier",
    "creation": 1,
    "diffusion": 2,
    "diffusion_region": 16,
    "diffusion_france": 80,
    "diffusion_monde": 4,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Oui",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.82871,
      -0.6975078
    ]
  },
  {
    "nom": "Compagnie Les Gamettes",
    "annee": 1999,
    "adresse": "35 RUE DE DEGRE",
    "codepostal": 72000,
    "ville": "LE MANS",
    "mail": "",
    "www": "http://compagnielesgamettes.jimdo.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 4,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu scolaire",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      48.0148721,
      0.1832314
    ]
  },
  {
    "nom": "COMPAGNIE ROBIN JUTEAU",
    "annee": 1993,
    "adresse": "35 RUE DE DEGRÉ",
    "codepostal": 72000,
    "ville": "LE MANS",
    "mail": "virna@cie-robinjuteau.com",
    "www": "http://www.cie-robinjuteau.com/",
    "reseaux": "Réseau JP Sarthe",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 3,
    "diffusion_region": 25,
    "diffusion_france": 5,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      48.0148721,
      0.1832314
    ]
  },
  {
    "nom": "compagnie 7ème Acte",
    "annee": 2008,
    "adresse": "35 rue de Degré - Bâtiment B - Appt 202",
    "codepostal": 72000,
    "ville": "LE MANS",
    "mail": "compagnie7emeacte@orange.fr",
    "www": "http://www.compagnie7emeacte.fr",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 1,
    "diffusion": 5,
    "diffusion_region": 75,
    "diffusion_france": 25,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      48.0148721,
      0.1832314
    ]
  },
  {
    "nom": "Karine Jarry",
    "annee": 2016,
    "adresse": "7 rue Letouzé",
    "codepostal": 72100,
    "ville": "Le Mans",
    "mail": "karinja.rry@gmail.com",
    "www": "",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Structures petite enfance",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Non",
    "coords": [
      47.9871238,
      0.2077613
    ]
  },
  {
    "nom": "Barons Freaks",
    "annee": 2012,
    "adresse": "Centre Artistique Intercommunal Jean Françaix",
    "codepostal": 72120,
    "ville": "Saint Calais",
    "mail": "baronsfreaks@ammd.net",
    "www": "http://www.baronsfreaks.org",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 90,
    "diffusion_france": 10,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Oui",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
        47.926429, 0.752134
    ]
  },
  {
    "nom": "Stéphanie Hauteville",
    "annee": 2011,
    "adresse": "18 rue Joseph Julien Aleton",
    "codepostal": 72220,
    "ville": "Marigné-Laillé",
    "mail": "stephanie.hauteville@gmail.com",
    "www": "",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 3,
    "diffusion": 2,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Lieux patrimoniaux / Musées",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "Conte, dessin",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.8174614,
      0.339479
    ]
  },
  {
    "nom": "La Compagnie de Danse l'Eventail",
    "annee": 1985,
    "adresse": "10 bis, avenue de Buckeburg",
    "codepostal": 72300,
    "ville": "Sablé sur Sarthe",
    "mail": "eventail.lschafer@orange.fr",
    "www": "http://compagnie-eventail.com",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Avec le Ministère de la Culture",
    "structure_associee": "Non",
    "creation": 4,
    "diffusion": 4,
    "diffusion_region": 19,
    "diffusion_france": 75,
    "diffusion_monde": 6,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Lieux patrimoniaux / Musées\nSalles polyvalentes\nMilieu scolaire\nHôpitaux\nDans l’espace public",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.8377314,
      -0.3437657
    ]
  },
  {
    "nom": "L'Arsenal d'apparitions",
    "annee": 2004,
    "adresse": "34, rue d'Estournelles de Constant",
    "codepostal": 72600,
    "ville": "Mamers",
    "mail": "larsenaldapparitions@gmail.com",
    "www": "http://www.larsenaldapparitions.fr",
    "reseaux": "Enfance et musique",
    "lieu_creation": "Non",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 6,
    "diffusion_region": 74,
    "diffusion_france": 25,
    "diffusion_monde": 1,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Structures petite enfance",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Theâtre musical",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      48.3495678,
      0.3659788
    ]
  },
  {
    "nom": "Betty BoiBrut'",
    "annee": 2011,
    "adresse": "223 rue de la Touche",
    "codepostal": 85270,
    "ville": "Saint Hilaire de Riez",
    "mail": "lucie@betty-boibrut.fr",
    "www": "http://www.betty-boibrut.fr",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 1,
    "diffusion": 0,
    "diffusion_region": 40,
    "diffusion_france": 60,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Dans l’espace public",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Non",
    "coords": [
      46.7182669,
      -1.9489168
    ]
  },
  {
    "nom": "Théâtre du Merle Blanc",
    "annee": 1998,
    "adresse": "Chemin des fontaines",
    "codepostal": 72400,
    "ville": "Boessé Le Sec",
    "mail": "",
    "www": "http://www.theatre-merle-blanc.com/",
    "reseaux": "",
    "lieu_creation": "NON",
    "lieu_diffusion": "NON",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 4,
    "diffusion_region": 30,
    "diffusion_france": 68,
    "diffusion_monde": 2,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Mairie\nCentre socio-culturels\nCollectivités",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Conte",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
        48.133025, 0.567913
    ]
  },
  {
    "nom": "Théâtre Tout Terrain",
    "annee": 2000,
    "adresse": "Vassé",
    "codepostal": 72140,
    "ville": "Rouessé-Vassé",
    "mail": "ttt@asso-ttt.com",
    "www": "http://asso-ttt.com/",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 0,
    "diffusion": 4,
    "diffusion_region": 90,
    "diffusion_france": 10,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Structures petite enfance\nCentre socio-culturels",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Chant",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      48.1593935,
      -0.1846447
    ]
  }
]
